import axios from "axios";

export const WHATSAPP_EVENT_API_PATH = "/api/event/whatsapp";

export function getWhatsAppRegistrationOptions({ eventId, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/registration-options`, { params: { event_id: Number(eventId) }, signal });
}

export function getWhatsAppRegistrationDeliveries({ eventId, page = 1, pageSize = 50, search = "", status = "", userType = "", date = "", timeZone = "America/Sao_Paulo", signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/registration-deliveries`, { params: { event_id: Number(eventId), page, page_size: pageSize, search, status, user_type: userType, date, time_zone: timeZone }, signal });
}

const eventParams = (eventId) => ({ event_id: Number(eventId) });

export const isWhatsAppRequestCancelled = (error) => (
  axios.isCancel(error) || error?.code === "ERR_CANCELED"
);

export function getWhatsAppSenders({ eventId, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/senders`, {
    params: eventParams(eventId),
    signal,
  });
}

export function getWhatsAppSettings({ eventId, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/settings`, {
    params: eventParams(eventId),
    signal,
  });
}

export function putWhatsAppSettings(payload) {
  return axios.put(`${WHATSAPP_EVENT_API_PATH}/settings`, payload);
}

export function getWhatsAppTemplates({ eventId, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/templates`, {
    params: eventParams(eventId),
    signal,
  });
}

export function previewWhatsAppCampaign(payload) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/campaigns/preview`, payload);
}

export function createWhatsAppCampaign(payload) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/campaigns`, payload);
}

export function getWhatsAppCampaigns({ eventId, page = 1, pageSize = 20, status, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/campaigns`, {
    params: { ...eventParams(eventId), page, page_size: pageSize, ...(status && status !== "all" ? { status } : {}) },
    signal,
  });
}

export function getWhatsAppCampaign({ campaignId, eventId, page = 1, pageSize = 20, search = "", status, signal } = {}) {
  return axios.get(
    `${WHATSAPP_EVENT_API_PATH}/campaigns/${encodeURIComponent(campaignId)}`,
    { params: { ...eventParams(eventId), page, page_size: pageSize, search, ...(status ? { status } : {}) }, signal },
  );
}

export function getWhatsAppParticipants({ eventId, search = "", page = 1, pageSize = 20, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/participants`, {
    params: { ...eventParams(eventId), search, page, page_size: pageSize }, signal,
  });
}

export function pauseWhatsAppCampaign({ campaignId, eventId, reason = null }) {
  return axios.post(
    `${WHATSAPP_EVENT_API_PATH}/campaigns/${encodeURIComponent(campaignId)}/pause`,
    { ...eventParams(eventId), reason },
  );
}

export function resumeWhatsAppCampaign({ campaignId, eventId }) {
  return axios.post(
    `${WHATSAPP_EVENT_API_PATH}/campaigns/${encodeURIComponent(campaignId)}/resume`,
    eventParams(eventId),
  );
}

export function cancelWhatsAppCampaign({ campaignId, eventId }) {
  return axios.post(
    `${WHATSAPP_EVENT_API_PATH}/campaigns/${encodeURIComponent(campaignId)}/cancel`,
    eventParams(eventId),
  );
}

export function getWhatsAppSuppressions({ eventId, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/suppressions`, {
    params: eventParams(eventId),
    signal,
  });
}

export function addWhatsAppSuppression(payload) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/suppressions`, payload);
}

export function releaseWhatsAppSuppression({ suppressionId, eventId, evidence }) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/suppressions/${encodeURIComponent(suppressionId)}/release`, {
    ...eventParams(eventId), evidence,
  });
}

export function getWhatsAppDelivery({ deliveryId, eventId, signal } = {}) {
  return axios.get(`${WHATSAPP_EVENT_API_PATH}/deliveries/${encodeURIComponent(deliveryId)}`, {
    params: eventParams(eventId), signal,
  });
}

export function resolveWhatsAppDelivery({ deliveryId, eventId, resolution, evidence, providerMessageId }) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/deliveries/${encodeURIComponent(deliveryId)}/resolve`, {
    ...eventParams(eventId), resolution, evidence, ...(providerMessageId ? { provider_message_id: providerMessageId } : {}),
  });
}

export function previewWhatsAppResend({ campaignId, payload }) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/campaigns/${encodeURIComponent(campaignId)}/resend/preview`, payload);
}

export function resendWhatsAppDeliveries({ campaignId, payload }) {
  return axios.post(`${WHATSAPP_EVENT_API_PATH}/campaigns/${encodeURIComponent(campaignId)}/resend`, payload);
}
